import reducer from './reducers'

export { default as contactSelector } from './selectors'
// export { Contact, ContactState } from './types'

export default reducer
